import type ViewFilter from "owa-service/lib/contract/ViewFilter";

export const ALL_TAB_KEY = "all";
export const UNREAD_TAB_KEY = "unread";

/**
 * Maps the table's view filter onto the Unread | All pivot's tab key.
 *
 * Filters the pivot does not represent resolve to an empty key so that neither tab is shown as
 * selected. Falling back to the All tab would be wrong, because the list is in fact filtered; the
 * filter menu button surfaces the active filter in that case.
 */
export default function getTabKeyForViewFilter(viewFilter: ViewFilter | null | undefined): string {
    switch (viewFilter) {
        case "All":
            return ALL_TAB_KEY;
        case "Unread":
            return UNREAD_TAB_KEY;
        default:
            return "";
    }
}

export function getViewFilterForTabKey(key: string): ViewFilter {
    return key === UNREAD_TAB_KEY ? "Unread" : "All";
}
